import React, { useState, useEffect, useCallback } from 'react';
import { ModalParams } from '../../../services/modal_service';
import ModalBackdrop from './modal_backdrop';
import ModalHeader from './modal_header';

const ModalContainer = ({
  onOpen,
}: {
  onOpen: (
    openHandler: (params: ModalParams) => void,
    updateHandler: (params: Partial<ModalParams>) => void,
    closeHandler: () => void,
  ) => void;
}) => {
  const [currentModal, setCurrentModal] = useState<ModalParams | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  const openModal = useCallback((params: ModalParams) => {
    setCurrentModal({ ...params, props: { ...params.props } });
    setTimeout(() => setIsVisible(true), 0);
  }, []);

  const updateModal = useCallback((params: Partial<ModalParams>) => {
    setCurrentModal((prev) => ({
      ...prev,
      ...params,
      props: { ...prev?.props, ...params.props },
    }));
  }, []);

  const closeModal = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => setCurrentModal(null), 300);
  }, []);

  const handleDismiss = useCallback(() => {
    if (currentModal?.onDismiss) {
      currentModal.onDismiss();
    } else {
      closeModal();
    }
  }, [currentModal, closeModal]);

  useEffect(() => {
    onOpen(openModal, updateModal, closeModal);

    return () => {
      setCurrentModal(null);
      setIsVisible(false);
    };
  }, [onOpen, openModal, updateModal, closeModal]);

  if (!currentModal?.component) {
    return null;
  }

  return (
    <>
      <ModalBackdrop onClick={handleDismiss} />
      <div
        className={`modal fade ${isVisible ? 'in' : ''}`}
        role="dialog"
        style={{ zIndex: 1050, display: 'block' }}
        onClick={handleDismiss}
      >
        <div
          className={`modal-dialog ${currentModal.size ? `modal-${currentModal.size}` : ''}`}
          onClick={(event) => event.stopPropagation()}
        >
          <div className="modal-content">
            <ModalHeader closeModal={handleDismiss} title={currentModal.props?.title || ''} />
            <currentModal.component {...currentModal.props} closeModal={closeModal} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalContainer;
